import { useParams } from 'react-router-dom';

import { useIsSduSupported } from 'src/ui/containers/endpoints/utils/useIsSduSupported';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import {
  Connection,
  GetPlatformTrackingStatusQuery,
  useGetPlatformTrackingStatusQuery,
} from 'src/ui/graph/types';
import { getYesterdayUtcDateString } from 'src/ui/utils/dateUtils';

export const isTrackingUpToDate = (
  status: GetPlatformTrackingStatusQuery['getPlatformTrackingStatus']
): boolean =>
  status?.date === getYesterdayUtcDateString() &&
  status?.syncStatus === 'completed';

export const useSduTrackingStatus = (connection: Connection) => {
  const { org = '' } = useParams<{ org?: string }>();
  const isSduSupported = useIsSduSupported(connection);

  const { data: trackingData } = useGetPlatformTrackingStatusQuery(
    graphQLClient,
    { connectionId: connection.id, org_domain: org },
    { enabled: isSduSupported }
  );

  const trackingStatus = trackingData?.getPlatformTrackingStatus;

  return {
    isSduSupported,
    disabled: isTrackingUpToDate(trackingStatus),
    inProgress: trackingStatus?.syncStatus === 'in_progress',
  };
};
